import React from 'react';
import PropTypes from 'prop-types';
import { Button, Heading } from '@massds/mayflower-react';

import './index.scss';

const TreeTableButtons = (props) => {
  const { headerLevel, a11yTitle, buttons } = props;
  return(
    <div className="ma__button-wrapper">
      <Heading class="ma__visually-hidden" level={headerLevel} text={`${a11yTitle} View Options`} />
      <ul>
        {buttons.map((button, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`treetable-button-${index}`}>
            <Button
              size="small"
              usage={button.usage}
              info={button.info}
              text={button.text}
              type="button"
              onClick={button.onClick}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

TreeTableButtons.propTypes = {
  /** The hidden title for a11y */
  a11yTitle: PropTypes.string.isRequired,
  /** The header level of the a11y header, default level 4. */
  headerLevel: PropTypes.number,
  /** An array of button that control the expand/collapse of tree table rows */
  buttons: PropTypes.arrayOf(PropTypes.shape({
    /** The button usage. */
    usage: PropTypes.string,
    /** The button information */
    info: PropTypes.string,
    /** The text displayed on the buttons */
    text: PropTypes.string,
    /** Custom on click function */
    onClick: PropTypes.func
  }))
};

TreeTableButtons.defaultProps = {
  headerLevel: 4
};

export default TreeTableButtons;
